import { Data } from "@angular/router";
import { InvitationDetails } from "./invitation";
import { OrganizationDetails } from "./organization";
import { UserDetails } from "./user";
import { AdminRouteData } from "../shared/resolvers/admin-resolver";

export interface BaseRouteData extends Data {
  user: UserDetails;
}

export interface UserRouteData extends Data {
  user: UserDetails;
}

export interface OrganizationRouteData extends BaseRouteData {
  organization: OrganizationDetails;
}

export interface InvitationsRouteData extends Data {
  invitations: InvitationDetails[];
}

export interface OrganizationUserRouteData extends Data {
  organization: OrganizationDetails;
  user: UserDetails;
}

export function isOrganizationUserRouteData(obj: Data): obj is OrganizationUserRouteData {
  return (
    obj !== null &&
    typeof obj === "object" &&
    "organization" in obj &&
    "user" in obj &&
    OrganizationDetails.isOrganizationDetails(obj["organization"]) &&
    UserDetails.isUserDetails(obj["user"])
  );
}

export function isUserRouteData(obj: Data): obj is UserRouteData {
  return obj !== null && typeof obj === "object" && "user" in obj && UserDetails.isUserDetails(obj["user"]);
}

export function isInvitationsRouteData(obj: Data): obj is InvitationsRouteData {
  return (
    obj !== null &&
    typeof obj === "object" &&
    "invitations" in obj &&
    Array.isArray(obj["invitations"]) &&
    (obj["invitations"] as InvitationDetails[]).every(InvitationDetails.isInvitationDetails)
  );
}

export function isAdminRouteData(obj: Data): obj is AdminRouteData {
  return obj !== null && typeof obj === "object" && "isAdminArea" in obj && typeof obj["isAdminArea"] === "boolean";
}
